import React from 'react';
import { useModalMethods } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';

const OpenChangeAcceptanceDateModal = ({ dateType, children }) => {
  const { open } = useModalMethods();

  const handleClick = (e) => {
    open(modalNames.changeAcceptanceDate, { mutableEntity: dateType });
  };

  return <div onClick={handleClick}>{children}</div>;
};

export default OpenChangeAcceptanceDateModal;
